// extracted by mini-css-extract-plugin
export default {"root":"StateLicenseListItem_root__9RYB+","licenseIcon":"StateLicenseListItem_licenseIcon__dhvAf"};